<template>
  <v-content class="grey lighten-4">
    <AppBar title="Tågsök" :extension-height="110">
      <template v-slot:extension>
        <v-container class="py-0">
          <v-form @submit.prevent="search">
            <v-row>
              <div class="d-flex flex-column align-center pt-3">
                <v-icon size="20">mdi-train</v-icon>
                <div class="py-1" style="height: 30px"></div>
                <v-icon size="20">mdi-calendar-range</v-icon>
              </div>
              <v-col class="py-0">
                <v-text-field
                  v-model.number="trip"
                  type="number"
                  block
                  dense
                  outlined
                  hide-details
                  class="mb-3"
                  placeholder="Sök på tågnr..."
                />
                <div class="d-flex">
                  <v-text-field
                    v-model="date"
                    type="date"
                    dense
                    outlined
                    hide-details
                    class="mb-3"
                  />
                  <v-btn
                    type="submit"
                    :loading="loading"
                    style="height: 40px"
                    class="ml-2"
                    color="primary"
                    >Sök</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </template>
    </AppBar>
    <AppNavigationDrawer />

    <v-container class="px-0">
      <transition name="scroll-y-transition" mode="out-in">
        <div v-if="loading" class="d-flex flex-column align-center pt-12">
          <v-progress-circular size="56" indeterminate color="primary" />
          <span class="mt-4 grey--text text--darken-1"
            >Hämtar besättning...</span
          >
        </div>
        <div v-else-if="!loading && data.length">
          <CrewListItem
            :employee="item.Employee"
            :trip="tripData"
            :date="date"
            :activities="item.Pieces"
            v-for="(item, $i) of data"
            :key="$i"
          />
        </div>
        <div v-else class="d-flex flex-column align-center pt-12">
          <v-icon size="50">mdi-information-outline</v-icon>
          <span class="grey--text text--darken-1"
            >Ingen besättning hittades</span
          >
        </div>
      </transition>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'
import CrewListItem from '@/components/CrewListItem'
import { queryDuty } from '@/api/queryDuty'
import { format } from 'date-fns'

export default {
  name: 'Crew',

  components: {
    AppBar,
    AppNavigationDrawer,
    CrewListItem
  },

  data: () => ({
    trip: '',
    loading: false,
    tripData: null,
    date: format(new Date(), 'yyyy-MM-dd'),
    data: []
  }),

  created() {
    if (this.$route.params.trip) {
      this.trip = parseInt(this.$route.params.trip, 10)
    }

    if (this.$route.params.date) {
      this.date = this.$route.params.date
    }

    if (this.trip && this.date) {
      this.fetch(this.trip, this.date)
    }
  },

  filters: {
    time(date) {
      return format(new Date(date), 'HH:mm')
    }
  },

  methods: {
    search() {
      this.data = []
      this.fetch(this.trip, this.date)
    },

    async fetch(trip, date) {
      this.loading = true

      const query = {
        $filter: ` Pieces/any(p: p/Trip eq ${trip} and p/AbsenceTypeId eq null) and dutyDate eq ${date} and districtId eq ${this.$store.get(
          'sso/districtId'
        )}`,
        $expand: 'Employee, Pieces($orderby=StartTime)',
        $select: 'Employee, Pieces'
      }
      const data = await queryDuty(query)
      this.tripData = trip
      this.data = data.sort(
        (a, b) =>
          +new Date(a.Pieces[0].StartTime) - +new Date(b.Pieces[0].StartTime)
      )

      this.loading = false
    },

    refresh() {
      this.fetch()
    }
  }
}
</script>
